"use strict";
const Toggle = (onClick, isActive) => {
  const toggleElm = document.createElement("div");
  toggleElm.onclick = () => {
    toggleElm.childNodes[1].classList.toggle("fa-toggle-off");
    toggleElm.childNodes[1].classList.toggle("fa-toggle-on");
    onClick();
  };
  toggleElm.classList.add("toggle");
  toggleElm.innerHTML = `
  <i class="fas clickable fa-toggle-${isActive ? "on" : "off"}"></i>`;
  return toggleElm;
};

export default Toggle;
